export interface BulkUserCreationProps {
  onClose: () => void;
}

export enum BULK_USER_TRACK_EVENTS {
  STARTED = 'users_bulk_creation_funnel_started',
  KNOWLEDGE_BASE_OPENED = 'users_bulk_creation_funnel_knowledge_base_opened',
  TEMPLATE_DOWNLOAD = 'users_bulks_creation_funnel_template_download',
  FILE_REJECTED = 'users_bulk_creation_funnel_file_rejected',
  FILE_SELECTED = 'users_bulk_creation_funnel_file_selected',
  FILE_SUBMITTED = 'users_bulk_creation_funnel_file_submitted',
  FAILED = 'users_bulk_creation_funnel_failed',
  PARTIALLY_SUCCEEDED = 'users_bulk_creation_funnel_partially_succeeded',
  SUCCEEDED = 'users_bulk_creation_funnel_succeeded',
  STARTED_AGAIN = 'users_bulk_creation_funnel_started_again',
}
